import api, { API } from "./api";

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd);
  return `${API}/files/${data.path}`;
}
